import React, { useEffect, useState } from 'react';

import { useTheme } from 'styled-components';
import { Icon } from '@iconify/react';

import * as S from './styles'
import { Switch, SwitchThumb } from '../../../components/Switch';
import { Popover, PopoverContent, PopoverTrigger } from '../../../components/Popover';
import Profile from '../../../components/Profile/Profile';
import ProfileOptionsNav from '../../../components/Profile/ProfileOptionsNav';
// import { LangChanger } from '../../../components/LangChanger';
import { RootStateBase } from '../../../store/baseStore';
import { useTranslation } from "react-i18next";
import { scan } from "react-scan";
import { IsDebug } from 'domain/utils/domainUtil';
import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { SetReduxView, SetSimulate, StatusRoute } from '../../../store/util/action/utilAction';
import { Button } from '../../../components/Button';
import { TestSSE } from '../../../store/authentication/action/authenticationAction';
import { StreamMessage } from 'domain/infra/data/api';
import { Label } from '../../../components/Basic/Label/label';

const connector = connectUtil(
  (state: RootStateBase) => ({
    userData: state.UtilReducer.UserData,
    reduxView: state.UtilReducer.ReduxView,
    devSimulate: state.UtilReducer.DevSimulate,
    sseValue: state.AuthenticationReducer.sseValue, //TODO REMOVER
    SSE_VALUEEnd: state.AuthenticationReducer.sseValueEnd,  //TODO REMOVER
  }), { SetReduxView, SetSimulate, TestSSE, StatusRoute }
);

interface Props extends PropsFromRedux<typeof connector> {
  toggleTheme?(): void;
  headerLeftInfo?: React.ReactNode | JSX.Element;
}

function Header(props: Props) {
  const theme = useTheme();
  const { t } = useTranslation();
  //const _userData = new UserData();
  const [scanState, setScan] = useState<boolean>(false)
  function devScan() {
    setScan(!scanState)
  }

  function reduxViewToogle() {
    props.SetReduxView({ ...props.reduxView, state: !props.reduxView.state })
  }

  function setSimulate() {
    props.SetSimulate(!props.devSimulate)
  }



  function onMessage(data: StreamMessage<number>) {
    console.log("onMessage aaaa", data.data);
  }

  function onError(event: Event) {
    console.log("onError aaaa", event)
  }

  function onOpen() {
    console.log("onOpen aaaa")
  }



  useEffect(() => { }, [props.SSE_VALUEEnd])

  function testSSE() {
    props.TestSSE(onError, onOpen, onMessage)
  }

  useEffect(() => {
    scan({
      enabled: scanState,
      showToolbar: scanState,
    });
  }, [scanState])

  return (
    <S.Container hasHeaderInfo={!!props.headerLeftInfo}>
      {props.headerLeftInfo}
      < S.RightContent >

        {IsDebug() &&
          <S.SwitchContainer >
            <Popover>
              <PopoverTrigger asChild>
                <Button size='sm' variant={'dev'}>DEV</Button>
              </PopoverTrigger>
              <PopoverContent side='bottom' sideOffset={10} avoidCollisions collisionPadding={10}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                  <S.DevLine>
                    <Label>React Scan</Label>
                    <Switch style={{ backgroundColor: theme.colors.dev }} onCheckedChange={devScan} checked={scanState}>
                      <SwitchThumb>

                        {
                          scanState ?
                            <Icon icon="material-symbols-light:logo-dev-rounded" height="1rem" />
                            : <Icon icon="material-symbols-light:logo-dev" height="1rem" color={theme.colors.primary} />
                        }

                      </SwitchThumb>
                    </Switch>
                  </S.DevLine>


                  <S.DevLine>
                    <Label>Redux</Label>
                    <Switch style={{ backgroundColor: theme.colors.dev }} onCheckedChange={reduxViewToogle} checked={props.reduxView.state}>
                      <SwitchThumb>
                        {
                          props.reduxView.state ?
                            <Icon icon="material-symbols-light:logo-dev-rounded" height="1rem" />
                            : <Icon icon="material-symbols-light:logo-dev" height="1rem" color={theme.colors.primary} />
                        }
                      </SwitchThumb>
                    </Switch>
                  </S.DevLine>


                  <S.DevLine>
                    <Label>Simular Erro</Label>
                    <Switch style={{ backgroundColor: theme.colors.dev }} onCheckedChange={setSimulate} checked={props.devSimulate}>
                      <SwitchThumb>

                        {
                          props.devSimulate ?
                            <Icon icon="material-symbols-light:logo-dev-rounded" height="1rem" />
                            : <Icon icon="material-symbols-light:logo-dev" height="1rem" color={theme.colors.primary} />
                        }

                      </SwitchThumb>
                    </Switch>
                  </S.DevLine>

                  <S.DevLine>
                    <Label>Teste SSE</Label>
                    <Button size='sm' onClick={testSSE}>{props.sseValue ?? "SSE"}</Button>
                  </S.DevLine>
                </div>
              </PopoverContent>
            </Popover>
          </S.SwitchContainer>
        }


        <S.SwitchContainer>
          {/* <LangChanger /> */}
        </S.SwitchContainer>

        <S.SwitchContainer>
          <Switch onCheckedChange={props.toggleTheme} checked={theme.title == 'dark'}>
            <SwitchThumb>
              {
                theme.title == 'light' ?
                  <Icon icon="line-md:moon-to-sunny-outline-transition" height="1rem" />
                  : <Icon icon="line-md:sunny-outline-to-moon-transition" height="1rem" color={theme.colors.primary} />
              }
            </SwitchThumb>
          </Switch>
        </S.SwitchContainer>



        <S.AvatarContainer>
          <Popover>
            <PopoverTrigger asChild>
              <div>
                <Profile sizeImage='sm' title={props.userData?.NomeExibicao ?? t("Carregando")} subtitle='Gerente' borderColor={theme.colors.negative} />
              </div>
            </PopoverTrigger>
            <PopoverContent side='bottom' sideOffset={10} avoidCollisions collisionPadding={10}>
              <ProfileOptionsNav />
            </PopoverContent>
          </Popover>
        </S.AvatarContainer>
      </S.RightContent >
    </S.Container >
  );
}

export default connector(Header);
